import { useEffect, useState } from "react";
import { IAnswersResult, TEST_STATUSES } from "../Tests/types";
import { TableBodyGetNotificationItem } from "src/components/tables/notificationTables/GetNotificationTable";
import { getItemsRequest } from "src/modules/spItems/api";
import { notificationTests, notificationTestsAnswers, notificationTestsQuestion } from "src/api/config/notifications.config";

export const useGetPassingTest = (item: TableBodyGetNotificationItem) => {
  const [resultPassingTest, setResultPassingTest] = useState<TEST_STATUSES>(TEST_STATUSES.NOT_STARTED);
  const [percentResultTest, setPercentResultTest] = useState(0);
  const [passingTestOpen, setPassingTestOpen] = useState(false);
  const [showResultsTest, setShowResultsTest] = useState(false);
  const [answersResult, setAnswersResult] = useState<IAnswersResult>({});

  const getPercentResultTest = (result: number) => setPercentResultTest(result);
  const getAnswersResult = (answers: IAnswersResult) => setAnswersResult(answers);
  const onResult = (testStatus: TEST_STATUSES) => setResultPassingTest(testStatus);
  const startPassingTest = () => setPassingTestOpen(!passingTestOpen);
  const availabilityTest = typeof item?.Test === "number" ? true : false;

  const [notificationTestQuestions, setNotificationTestQuestions] = useState<any>([]);
  const [notificationTestQuestionsID, setQuestionsID] = useState<any>([]);
  const [notificationTestAnswers, setNotificationTestAnswers] = useState<any>([]);
  const [minCorrectAnswerCount, setMinCorrectAnswerCount] = useState(1);
  const [titleTest, setTitleTest] = useState("");

  async function getItemsRequestAsync() {
    if (item?.Test) {
      const test = await getItemsRequest({
        listName: notificationTests,
        filters: { ID: item?.Test }
      });
      const questionsIDList = test.items[0].Questions.map(question => question.get_lookupId());

      const questionsList = await getItemsRequest({
        listName: notificationTestsQuestion,
        filters: { ID: questionsIDList }
      });

      const answersIDList = questionsList.items.map(question => question.Answers.map(answer => answer.get_lookupId())).flat();

      const answersList = await getItemsRequest({
        listName: notificationTestsAnswers,
        filters: { ID: answersIDList }
      });

      setNotificationTestAnswers(answersList.items);

      setNotificationTestQuestions(
        questionsList.items.map(question => {
          return {
            ID: question.ID,
            Description: question.Description,
            Type: question.Type,
            Answers: question.Answers.map(answer => {
              return {
                Title: answer.get_lookupValue(),
                ID: answer.get_lookupId()
              };
            }),
            Title: question.Title
          };
        })
      );
      setQuestionsID(questionsIDList);
      setMinCorrectAnswerCount(test.items[0].MinCorrectAnswerCount);
      setTitleTest(test.items[0].Title);
    }
  }

  useEffect(() => {
    if (item.NotificationType.ID !== 6 && availabilityTest) getItemsRequestAsync();
  }, [item?.Test]);

  const notificationsTestsAnswers =
    item.NotificationType.ID !== 6 && availabilityTest
      ? notificationTestAnswers.map((answer: any) => {
        return {
          ID: answer.ID,
          Description: answer.Description,
          IsCorrect: answer.IsCorrect,
          Title: answer.Title
        };
      })
      : "";

  const questions =
    item.NotificationType.ID !== 6 && availabilityTest
      ? notificationTestQuestions.map((question: any) => ({
        Description: question.Description,
        ID: question.ID.toString(),
        Answers: question.Answers.map((answerID: { Title: string; ID: number }) => notificationsTestsAnswers.find((answer: any) => answer?.ID === answerID?.ID)),
        Type: question.Type
      }))
      : "";

  return {
    resultPassingTest,
    percentResultTest,
    showResultsTest,
    answersResult,
    notificationTestQuestionsID,
    minCorrectAnswerCount,
    titleTest,
    questions,
    availabilityTest,
    passingTestOpen,
    getPercentResultTest,
    getAnswersResult,
    onResult,
    startPassingTest,
    setShowResultsTest
  };
};
